import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=28938a46&"
import script from "./DateComponent.vue?vue&type=script&lang=ts&"
export * from "./DateComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DateComponent.vue?vue&type=style&index=0&id=28938a46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports